"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var Sync_1 = require("@twii/core-ui-fabric/lib/component/Sync");
var ListingActivityList_classNames_1 = require("./ListingActivityList.classNames");
var ListingActivityList_styles_1 = require("./ListingActivityList.styles");
var DetailsList_1 = require("office-ui-fabric-react/lib/DetailsList");
var MomentDataUtils_1 = require("@twii/core/lib/MomentDataUtils");
var MessageBar_1 = require("office-ui-fabric-react/lib/MessageBar");
var ActivityColumns = [
    {
        key: "field_name",
        name: "Field",
        fieldName: "field_name",
        minWidth: 100,
        isResizable: true
    },
    {
        key: "old_value",
        name: "Old Value",
        fieldName: "old_value",
        minWidth: 200,
        isResizable: true
    },
    {
        key: "new_value",
        name: "New Value",
        fieldName: "new_value",
        minWidth: 200,
        isResizable: true
    }
];
var ListingActivityListItems = /** @class */ (function (_super) {
    __extends(ListingActivityListItems, _super);
    function ListingActivityListItems() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderCell = function (nestingDepth, item, itemIndex) {
            return item.author.display_name;
        };
        _this._onShouldVirtualize = function () {
            return false;
        };
        _this._onRenderActivityHeader = function (props) {
            var activity = props.group.data.activity;
            return (React.createElement("div", { className: _this.props.classNames.itemsGroupHeader },
                React.createElement("strong", null, activity.action),
                " - ",
                activity.author.display_name,
                " - ",
                MomentDataUtils_1.timestampIO(activity.activity_date)));
        };
        return _this;
    }
    ListingActivityListItems.prototype.render = function () {
        var items = [];
        var groups = [];
        this.props.activityList.itemsView.forEach(function (activity, idx) {
            groups.push({
                key: String(idx),
                name: activity.action + " - " + activity.author.display_name + " - " + activity.activity_date,
                startIndex: items.length,
                count: activity.change_details.length,
                data: {
                    activity: activity
                }
            });
            activity.change_details.forEach(function (cd) {
                items.push(cd);
            });
        });
        if (items.length > 0) {
            return React.createElement(DetailsList_1.DetailsList, { groupProps: { onRenderHeader: this._onRenderActivityHeader, showEmptyGroups: true }, groups: groups, items: items, columns: ActivityColumns, layoutMode: DetailsList_1.DetailsListLayoutMode.fixedColumns, selectionMode: DetailsList_1.SelectionMode.none, onShouldVirtualize: this._onShouldVirtualize });
        }
        return (React.createElement("div", { style: { padding: 8 } },
            React.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.info }, "No Activities available")));
    };
    ListingActivityListItems = __decorate([
        mobx_react_1.observer
    ], ListingActivityListItems);
    return ListingActivityListItems;
}(React.Component));
var ListingActivityList = /** @class */ (function (_super) {
    __extends(ListingActivityList, _super);
    function ListingActivityList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingActivityList.prototype.render = function () {
        var classNames = ListingActivityList_classNames_1.getClassNames(ListingActivityList_styles_1.getStyles(undefined, this.props.styles), this.props.className);
        return (React.createElement("div", { className: classNames.root },
            React.createElement(ListingActivityListItems, __assign({}, this.props, { className: classNames.items, classNames: classNames }))));
    };
    return ListingActivityList;
}(React.Component));
exports.ListingActivityList = ListingActivityList;
var ListingActivityListContainer = /** @class */ (function (_super) {
    __extends(ListingActivityListContainer, _super);
    function ListingActivityListContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderDone = function () {
            return React.createElement(ListingActivityList, __assign({}, _this.props));
        };
        return _this;
    }
    ListingActivityListContainer.prototype.componentWillMount = function () {
        this.props.activityList.load();
    };
    ListingActivityListContainer.prototype.render = function () {
        return React.createElement(Sync_1.Sync, { sync: this.props.activityList.sync, onRenderDone: this._onRenderDone, syncLabel: "Loading Activity..." });
    };
    return ListingActivityListContainer;
}(React.Component));
exports.ListingActivityListContainer = ListingActivityListContainer;
